export const headerConfigMap = {
  initialPage: {
    title: "Informações Gerais",
    showBack: false,
    showFilter: true,
  },
  natureProduction: {
    title: "Produção",
    showBack: true,
    showFilter: true,
  },
  generalCondition: {
    title: "Condições Gerais",
    showBack: true,
    showFilter: true,
  },
  health: {
    title: "Saúde",
    showBack: true,
    showFilter: true,
  },
  agritourism: {
    title: "Agroturismo",
    showBack: true,
    showFilter: true,
  },
  education: {
    title: "Escolaridade",
    showBack: true,
    showFilter: true,
  },
  social: {
    title: "Aspectos socioeconômicos",
    showBack: true,
    showFilter: true,
  },
  ambiental: {
    title: "Características Ambientais e Agrotóxicos",
    showBack: true,
    showFilter: true,
  },
  fabricados: {
    title: "Produtos Fabricados",
    showBack: true,
    showFilter: true,
  },
  infra: {
    title: "Infraestrutura",
    showBack: true,
    showFilter: true,
  },
  obra: {
    title: "Gestão / Mão de Obra",
    showBack: true,
    showFilter: true,
  },
};
